export default import.meta.ROLLDOWN_FILE_URL_esplbrUk6HvuBYF_G50TZQ